// import { Component, ElementRef, inject, Input, ViewChild } from '@angular/core';
// import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
// import { UiformBaseComponent } from '../components/uiform/uiform-base/uiform-base.component';
// import { ServiceLocatorService } from '@ncs/ncs-lib';
// import { ActivatedRoute } from '@angular/router';
// import { ChangeDetectorRef } from '@angular/core';
// import { SharedataService } from '../common/service/sharedata.service';
// import { DatePipe } from '@angular/common';

// @Component({
//   selector: 'app-reports-list',
//   templateUrl: './reports-list.component.html',
//   styleUrls: ['./reports-list.component.css'],
// })
// export class ReportsListComponent extends UiformBaseComponent {
//   @ViewChild('content')
//   content!: ElementRef;
//   public reportData: any = {};
//   public show: boolean = false;
//   public loading: boolean = false;
//   dropdownOpen: boolean = false;
//   public searchReport: any;
//   public selectedSearchAtt: any;
//   @Input() searchList: any[] = [];

//   public reqform: any = {
//     chart_type: 'html',
//     margins: false,
//   };
//   public pivotform: any = {
//     chart_type: 'html',
//   };
//   public sanitizedData: any = [];
//   private sanitizer = inject(DomSanitizer);
//   pivotUrl: SafeResourceUrl | null = null;
//   pivottable: any = '<div><div>';
//   public reportTitle: any = '';
//   public reportId: number | null = 0;
//   public override appId: any = null;
//   public appName: any;
//   public orgName: any;
//   public appLogoId: any;
//   public orgLogoId: any;
//   searchData: any = {};
//   searchView: any = {};
//   chartUrl: string | null = null;

//   constructor(
//     public override locator: ServiceLocatorService,
//     public override route: ActivatedRoute,
//     private cdRef: ChangeDetectorRef,
//     private sharedata: SharedataService,
//   ) {
//     super(locator, route);
//     let _self = this;

//     const reportIdParam = route.snapshot.paramMap.get('reportId');
//     const appIdParam =
//       route.snapshot.paramMap.get('appId') || route.snapshot.paramMap.get('id');

//     if (reportIdParam) {
//       _self.reportId = Number(reportIdParam);
//     }

//     if (appIdParam) {
//       _self.appId = Number(appIdParam);
//     }

//     // Also check path variables dynamically
//     _self.locator.getPathVariable(route, function (params: any) {
//       if (params['reportId']) {
//       _self.reportId = locator.dataValidator.toInt(params['reportId']);
//       }
//       if (params['appId'] || params['id']) {
//         _self.appId = locator.dataValidator.toInt(
//           params['appId'] || params['id'],
//         );
//       }
//       _self.ngOnInit();
//     });
//   }

//   override ngOnInit() {
//     let _self = this;
//     let keySuffix = _self.locator.config.get('CONTEXT_PATH') + '-';
//     _self.appName = localStorage.getItem(keySuffix + 'appName');
//     _self.orgName = localStorage.getItem(keySuffix + 'orgName');
//     _self.orgLogoId = localStorage.getItem(keySuffix + 'orgLogo');
//     _self.appLogoId = localStorage.getItem(keySuffix + 'appLogoId');

//     // Initialize searchList if not provided
//     if (!_self.searchList || !Array.isArray(_self.searchList)) {
//       _self.searchList = [];
//     }

//     if (_self.reportId && _self.reportId > 0) {
//       _self.getReportData(_self.reportId);
//     }
//   }

//   /**
//    * Get Report Data
//    * @param id
//    * @returns
//    */
//   public getReportData(id: number | null) {
//     let _self = this;
//     if (!id || !(id > 0)) {
//       return;
//     }
//     _self.locator.config
//       .getProperty('endpoint.reports')
//       .then((property: string) => {
//         let url = property + '/get/' + id;
//         _self.locator.http.get(url, function (res: any, error: boolean) {
//           if (error) {
//             alert('Server Error:' + error);
//             return;
//           }
//           _self.form['data'] = res.result['data'];

//           _self.searchList = res.result['data']?.searchList || [];
//           _self.getDetails(
//             true,
//             res.result['data']['dataJson'],
//             res.result['data']['title'],
//             res.result['data']['uiFormId']
//           );
//           _self.preload();
//         });
//       });
//   }

//   getReports(callback?: any) {
//     var _self = this;
//     _self.form.searchError = false;
//     _self.form.searchMessage = '';

//     _self.locator.config
//       .getProperty('endpoint.reports')
//       .then((property: string) => {
//         let url = property + '/search/' + _self.form.pageNo;

//         _self.locator.http.post(
//           url,
//           _self.form.searchParams,
//           function (res: any, error: any) {
//             if (error) {
//               if (callback) {
//                 callback(error);
//               }
//               return;
//             }

//             _self.form.searchError = !res.success;
//             _self.form.searchMessage = res.result['message'];

//             if (res.success) {
//               _self.form.list = res.result.data;
//               //Check empty list
//               if (_self.form.list.length == 0) {
//                 _self.form.message = 'No record found';
//                 _self.form.error = true;
//               }
//               if (callback) {
//                 callback();
//               }
//             }

//             if (callback) {
//               callback();
//             }
//           },
//         );
//       });
//   }

//   /**
//    * Toggle the value of Search button
//    */
//   showSearch() {
//     let _self = this;
//     _self.show = !_self.show;
//   }

//   //-------------------------------------------------------------------------------------------------------

//   /**
//    * Reset search from
//    */
//   override resetSearchForm() {
//     this.form.searchError = false;
//     this.form.searchMessage = '';
//     this.form.searchParams = {};
//   }

//   override preload() {
//     var _self = this;
//     _self.form.error = false;
//     _self.form.message = '';
//     this.locator.config
//       .getProperty('endpoint.reports')
//       .then((property: any) => {
//         this.locator.http.get(_self.api.preload, (res: any, error: any) => {
//           if (error) {
//             return;
//           }
//           _self.form.error = !res.success;
//           _self.form.message = res.result.message;
//           if (res.success) {
//             _self.form.preload = res.result;
//             // Set a 2-second delay to call clearMessage
//             setTimeout(() => {
//               this.clearMessage(_self.form);
//             }, 2000);
//           }
//         });
//       });
//   }

//   /**
//    * Main function to get Pivot GUI
//    * @param flag
//    */
//   async searchAndDraw(flag: boolean, searchdata: any, title: any) {
//     let _self = this;
//     _self.reportTitle = title;
//     _self.reqform = searchdata;
//     if (flag) {
//       this.searchCriteria(() => {
//         _self.cleanData();
//         _self.findNumericFields();
//         _self.getPivotGui();
//       });
//     } else {
//       _self.getPivotGui();
//     }
//   }

//   /**
//    * Remove common attributes from searched result data
//    */
//   public cleanData(): any {
//     let _self = this;

//     // ✅ ADD THIS BLOCK HERE (START)
//     if (!_self.usecaseData || !_self.usecaseData.length) {
//       console.warn('cleanData skipped: empty usecaseData');
//       _self.sanitizedData = [];
//       return;
//     }

//     const allowedKeysMap = _self.filterAttributes.reduce(
//       (map: any, attr: any) => {
//         if (attr['code'] && attr['label']) {
//           map[attr['code']] = attr['label'];
//         }
//         return map;
//       },
//       {},
//     );

//     _self.sanitizedData = _self.usecaseData.map((item: any) => {
//       const sanitizedItem: any = {};
//       Object.keys(allowedKeysMap).forEach((key: string) => {
//         if (key in item) {
//           sanitizedItem[allowedKeysMap[key]] = item[key];
//         }
//       });
//       return sanitizedItem;
//     });
//   }

//   /**
//    * Create Pivot GUI from server side
//    */
//   getPivotGui() {
//     let _self = this;
//     _self.loading = true;
//     _self.reportData = {};
//     _self.form['error'] = false;
//     _self.form['message'] = '';
//     _self.pivottable = '';
//     _self.pivotUrl = null;
//     _self.reqform['title'] = _self.usecase['name'];
//     _self.reqform['values'] = this.reqform['aggfunc']
//       ? Object.keys(this.reqform['aggfunc'])
//       : [];
//     _self.reqform['numericfields'] = _self.findNumericFields();
//     _self.reportData = _self.reqform;

//     // 💣 ADD THIS HERE (IMPORTANT SAFETY CHECK)
//     if (!_self.sanitizedData || !_self.sanitizedData.length) {

//       console.warn('No sanitized data for pivot');

//       _self.pivottable = '';
//       _self.pivotUrl = null;

//       _self.form.error = true;
//       _self.form.message = 'No data found';

//       _self.loading = false;
//       return;
//     }

//     if (_self.reqform['chart_type'] === 'html') {
//       _self.locator.config
//         .getProperty('endpoint.pivot')
//         .then((property: string) => {
//           let url = _self.urlRewrite(property);

//           _self.reqform['data'] = _self.sanitizedData;

//           let client = _self.locator.http.getClient();

//           client.post(url, _self.reqform, { responseType: 'text' }).subscribe(
//             (data: any) => {

//               try {
//                 const jsonResponse = JSON.parse(data);
//                 if (!jsonResponse['success']) {
//                   _self.form['error'] = true;
//                   _self.form['message'] = jsonResponse['message'];
//                   _self.loading = false;
//                   return;
//                 }
//               } catch (error) {
//                 console.error('Error parsing JSON from Blob:', error);
//               }
//               _self.pivottable = data;
//               _self.loading = false;
//             },
//             (data: any) => {
//               console.error(data);
//               _self.loading = false;
//             }
//           );
//         });
//     } else {
//       _self.locator.config
//         .getProperty('endpoint.pivot')
//         .then((property: string) => {
//           let url = _self.urlRewrite(property);
//           _self.reqform['data'] = _self.sanitizedData;
//           let client = _self.locator.http.getClient();
//           client.post(url, _self.reqform, { responseType: 'blob' }).subscribe(
//             (data: any) => {
//               const contentType = data.type;
//               if (contentType.includes('application/json')) {
//                 const reader = new FileReader();
//                 reader.onload = () => {
//                   const text = reader.result as string;
//                   try {
//                     const jsonResponse = JSON.parse(text);
//                     if (!jsonResponse['success']) {
//                       _self.form['error'] = true;
//                       _self.form['message'] = jsonResponse['message'];
//                     }
//                   } catch (error) {
//                     console.error('Error parsing JSON from Blob:', error);
//                   }
//                 };
//                 reader.readAsText(data);
//               } else {
//                 const objectUrl = URL.createObjectURL(data);
//                 _self.pivotUrl =
//                   this.sanitizer.bypassSecurityTrustResourceUrl(objectUrl);
//               }
//               _self.loading = false;
//             },
//             (data: any) => {
//               _self.loading = false;
//             }
//           );
//         });
//     }
//   }

//   /**
//    * Function to find all numeric fields
//    * @returns
//    */
//   findNumericFields = () => {
//     const numericFields = new Set();
//     this.sanitizedData.forEach((item: any) => {
//       Object.keys(item).forEach((key) => {
//         if (typeof item[key] === 'number') {
//           numericFields.add(key);
//         }
//       });
//     });
//     return Array.from(numericFields);
//   };

//   /**
//    * Reset search values
//    */
//   resetSearchValues() {
//     this.searchValues = {};
//     this.searchAndDrawnew(true);
//   }

//   /**
//    * Update form field
//    * @param field
//    * @param value
//    * @param aggValue
//    * @param isKey
//    */
//   updateFormField(
//     field: string,
//     value: any,
//     aggValue?: any,
//     isKey: boolean = false
//   ) {
//     this.reqform[field] = this.reqform[field] || (isKey ? {} : []);
//     if (isKey) {
//       aggValue = aggValue?.trim() || 'sum';
//       this.reqform[field][value] = aggValue;
//     } else {
//       this.reqform[field].push(value);
//     }
//   }

//   /**
//    * Remove form field
//    * @param field
//    * @param value
//    * @param isKey
//    */
//   removeFormField(field: string, value: any, isKey: boolean = false) {
//     if (isKey) {
//       delete this.reqform[field]?.[value];
//     } else if (Array.isArray(this.reqform[field])) {
//       const index = this.reqform[field].indexOf(value);
//       if (index > -1) this.reqform[field].splice(index, 1);
//     }
//   }

//   /**
//    * Search and draw pivot data
//    * @param flag
//    * @param searchdata
//    * @param title
//    * @param uiformId
//    */
//   async getDetails(flag: boolean, searchdata: any, title: any, uiformId: any) {
//     let _self = this;
//     _self.is_paging = false;

//     if (uiformId) {
//       try {
//         const endpoint = await _self.locator.config.getProperty(
//           'endpoint.ui.forms'
//         );

//         await new Promise<void>((resolve) => {
//           _self.get(uiformId, async function () {
//             _self.usecaseId = _self.form.data.userstoryId;

//             await _self.getUsecaseSchema(false, async () => {
//               _self.filterAttributes = await _self.getFilterAttributes(
//                 _self.usecaseAttributes,
//                 _self.form.data['fields']
//               );
//               resolve();
//             });
//           });
//         });

//         // Call searchAndDraw only after all operations are complete
//         _self.searchAndDraw(flag, searchdata, title);
//       } catch (error) {
//         console.error('Error in getDetails:', error);
//       }
//     }
//   }

//   /**
//    * Draw pivot data
//    * @param flag
//    */
//   searchAndDrawnew(flag: boolean) {
//     let _self = this;

//     if (flag) {
//       this.searchCriteria(() => {
//         _self.cleanData();
//         _self.findNumericFields();
//         _self.getPivotGui();
//       });
//     } else {
//       _self.getPivotGui();
//     }
//   }

//   /**
//    * search for parent usecase dependency
//    * @param e
//    * @param value
//    */
//   override onSearchReferenceValueChange(e: any, value: any) {
//     this.searchValues[e.code] =
//       e.type === 'number' ? parseFloat(value.target.value) : value.target.value;
//     let _self = this;
//     if (
//       _self.usecase !== undefined &&
//       _self.usecase['parentUsecaseDependency'] !== undefined &&
//       _self.usecase['parentUsecaseDependency'][e['primaryUsecase']] !==
//         undefined
//     ) {
//       _self.primaryUsecaseDependencyFilter(
//         _self.usecase['parentUsecaseDependency'][e['primaryUsecase']],
//         value
//       );
//     }
//   }

//   /***
//    * primaryUsecaseDependencyFilter
//    */
//   primaryUsecaseDependencyFilter(data: any, val: any) {
//     let _self = this;
//     let key = val['target']['id'];
//     let [appCode, codes] = (data['code'] ?? '').toString().split('.');
//     let url =
//       _self.locator.config.get('endpoint.api.v1') +
//       '/' +
//       appCode +
//       '/' +
//       codes +
//       '/preloadData';
//     let searchParams = {
//       [key]: parseFloat(val['target']['value']),
//     };
//     _self.locator.http.post(
//       url,
//       searchParams,
//       function (res: any, error: boolean) {
//         if (error) {
//           return;
//         }
//         _self.form.preload[data['code']] = res.result[data['code']];
//       }
//     );
//   }

//   /**
//    * add search data
//    */
//   // addSearchData() {
//   //   let _self = this;

//   //   if (!_self.searchData['field']) {
//   //     alert('Field is empty');
//   //     return;
//   //   } else if (!_self.searchData['condition']) {
//   //     alert('Condition is empty');
//   //     return;
//   //   } else if (!_self.searchData['value']) {
//   //     alert('Value is empty');
//   //     return;
//   //   } else {
//   //     _self.searchList.push(_self.searchData);
//   //     _self.searchData = {};
//   //   }
//   //   this.searchView['field'] = '';
//   // }

//   addSearchData() {
//     let _self = this;

//     // Date validation and today/yesterday detection
//     if (
//       _self.selectedSearchAtt === 'date' &&
//       _self.searchData['condition'] !== 'BETWEEN'
//     ) {
//       if (
//         _self.searchData['condition'] !== 'DAY' &&
//         _self.searchData['condition'] !== 'MONTH' &&
//         _self.searchData['condition'] !== 'DAY_AND_MONTH' &&
//         ['NULL', 'NOT NULL', 'EMPTY'].indexOf(_self.searchData['condition']) ===
//           -1
//       ) {
//         if (!_self.searchData['value']) {
//           alert('Date is empty');
//           return;
//         } else {
//           const searchDate = new Date(_self.searchData['value']);
//           const currentDate = new Date();
//           const yesterDate = new Date();

//           searchDate.setHours(0, 0, 0, 0);
//           currentDate.setHours(0, 0, 0, 0);
//           yesterDate.setDate(currentDate.getDate() - 1);
//           yesterDate.setHours(0, 0, 0, 0);

//           if (searchDate.getTime() === currentDate.getTime()) {
//             _self.searchData['date'] = 'today';
//           } else if (searchDate.getTime() === yesterDate.getTime()) {
//             _self.searchData['date'] = 'yesterday';
//           } else {
//             console.log('The date is neither today nor yesterday.');
//           }
//         }
//       }
//     }

//     // Parse rangeDate from ngxDaterangepickerMd
//     if (_self.searchData['rangeDate']) {
//       _self.searchData['rangeFrom'] =
//         _self.searchData.rangeDate.startDate.format('YYYY-MM-DD');
//       _self.searchData['rangeTo'] =
//         _self.searchData.rangeDate.endDate.format('YYYY-MM-DD');
//     }

//     // Field validation
//     if (!_self.searchData['field']) {
//       alert('Field is empty');
//       return;

//       // Condition validation
//     } else if (!_self.searchData['condition']) {
//       alert('Condition is empty');
//       return;

//       // BETWEEN handling
//     } else if (_self.searchData['condition'] === 'BETWEEN') {
//       if (!_self.searchData['rangeFrom']) {
//         alert('From value is empty');
//         return;
//       }

//       if (!_self.searchData['rangeTo']) {
//         alert('To value is empty');
//         return;
//       }

//       // ✅ Create copy for API (DO NOT MODIFY ORIGINAL OBJECT)
//       let payload = {
//         ..._self.searchData,
//         value: undefined,
//       };

//       // ✅ Push correct payload (for backend)
//       _self.searchList.push(payload);

//       // ✅ Add label for UI (IMPORTANT for your chip display)
//       _self.operators.forEach((e: any) => {
//         if (_self.searchData['condition'] === e.value) {
//           payload['label'] = _self.searchData['field']; // for UI
//           payload['conditionLabel'] = e.label; // optional
//         }
//       });

//       // Reset
//       _self.searchData = {};
//       _self.searchView['field'] = '';
//       _self.selectedSearchAtt = undefined;
//     } else {
//       // Skip value check for NULL / NOT NULL / EMPTY
//       if (
//         ['NULL', 'NOT NULL', 'EMPTY'].indexOf(_self.searchData['condition']) ===
//           -1 &&
//         !_self.searchData['value']
//       ) {
//       alert('Value is empty');
//       return;
//       }

//       // EMPTY condition for number field → set value to 0
//       if (
//         _self.searchData['condition'] === 'EMPTY' &&
//         _self.selectedSearchAtt === 'number'
//       ) {
//         _self.searchData['value'] = 0;
//       }

//       // Numeric field type coercion (your report-view logic)
//       const normalizedNumericFields = _self
//         .findNumericFields()
//         .map((label: any) => label.toLowerCase().replace(/\s+/g, ''));
//       const normalizedField = _self.searchData.field
//         .toLowerCase()
//         .replace(/\s+/g, '');

//       if (normalizedNumericFields.includes(normalizedField)) {
//         const numValue = Number(_self.searchData.value);
//         if (!isNaN(numValue)) {
//           _self.searchData.value = numValue;
//         }
//       }

//       // Push to searchList
//       _self.searchList.push(_self.searchData);

//       // Reset
//       _self.searchData = {};
//       _self.searchView['field'] = '';
//       _self.selectedSearchAtt = undefined;
//     }
//   }

//   /**
//    * Reset search data
//    * @param index
//    */
//   removeSearchData(index: any) {
//     if (index > -1) this.searchList.splice(index, 1);
//   }

//   /**
//    * Reset search criteria
//    */
//   resetSearchCriteria() {
//     this.searchList = [];
//     this.searchData = {};
//     this.searchView = {};
//   }

//   /**
//    * Search criteria
//    * @param callback
//    */
//   searchCriteria(callback?: any) {
//     let _self = this;

//     const datePipe = new DatePipe('en-US');
//     _self.searchList.forEach((e: any) => {
//       const currentDate = new Date();
//       if (e?.date === 'today') {
//         console.log('today');
//         e['value'] = datePipe.transform(currentDate, 'yyyy-MM-dd');
//       } else if (e?.date === 'yesterday') {
//         console.log('yesterday');
//         const yesterday = new Date(currentDate.getTime() - 1);
//         e['value'] = datePipe.transform(yesterday, 'yyyy-MM-dd');
//       }
//     });

//     let searchCriteria = {
//       searchList: _self.searchList,
//     };

//     let url = _self.apiurl + '/searchCriteria';

//     this.locator.http.post(
//       url,
//       searchCriteria,
//       function (res: any, error: any) {

//         console.log('API Response =>', res);
//         console.log('API Success =>', res?.success);
//         console.log('API Data =>', res?.result?.data);


//         if (error) {
//           if (callback) {
//             callback(error);
//           }
//           return;
//         }

//         if (res.success) {
//           // _self.usecaseData = res.result['data'];
//           _self.usecaseData = res.result['data'] || [];

//           console.log('Search Result =>', _self.usecaseData);

//           console.log('Search Result =>', res.result['data']);

//           // No data found
//           if (!_self.usecaseData.length) {

//             _self.sanitizedData = [];
//             _self.pivottable = '';
//             _self.pivotUrl = null;

//             _self.form.error = true;
//             _self.form.message = 'No data found';

//             _self.loading = false;

//             return;
//           }

//           if (callback) {
//             callback();
//           }
//         }
//         // if (callback) {
//         //   callback();
//         // }
//         _self.processData();
//       },
//     );
//   }

//   /**
//    * Button labels for pivot table
//    * @param type
//    * @returns
//    */
//   getButtonLabels(type: string): string {
//     const typeMap: { [key: string]: string } = {
//       text: 'T',
//       number: 'N',
//       long: 'L',
//       date: 'D',
//       decimal: 'Dc',
//       doc: 'Doc',
//       email: 'E',
//       expression: 'Exp',
//       file: 'F',
//       list: 'L',
//       map: 'C',
//       object: 'O',
//       password: 'Pwd',
//       phone: 'Phn',
//       textarea: 'TA',
//       url: 'Url',
//       time: 'T',
//     };
//     return typeMap[type] || '?';
//   }

//   /**
//    * Button class for pivot table
//    * @param type
//    * @returns
//    */
//   getButtonClass(type: string): string {
//     const typeClassMap: { [key: string]: string } = {
//       text: 'text-bg-success',
//       number: 'text-bg-primary',
//       date: 'text-bg-warning',
//       long: 'text-bg-primary',
//       decimal: 'text-bg-primary',
//       doc: 'text-bg-info',
//       email: 'text-bg-success', // Email gets green
//       expression: 'text-bg-info',
//       file: 'text-bg-secondary',
//       list: 'text-bg-danger', // List gets red
//       map: 'text-bg-dark', // Map gets dark
//       object: 'text-bg-secondary',
//       password: 'text-bg-warning',
//       phone: 'text-bg-success',
//       textarea: 'text-bg-success',
//       url: 'text-bg-info',
//       // Add new mappings
//       keyvalue: 'text-bg-info',
//       image: 'text-bg-info',
//     };
//     return typeClassMap[type] || 'text-bg-success'; // Default grey
//   }

//   /**
//    * Toggle dropdown
//    */
//   toggleDropdown() {
//     this.dropdownOpen = !this.dropdownOpen;
//   }

//   /**
//    * Select column value set
//    * @param value
//    * @param key
//    */
//   selectColumn(value: string, key: string) {
//     this.pivotform[key] = value;
//   }

//   /**
//    * Select search value set
//    * @param value
//    * @param key
//    */
//   selectSearch(value: any, key: string) {
//     this.searchData[key] = value['code'];
//     this.searchData['label'] = value['label'];
//     this.searchView[key] = value['label'];
//     if (key === 'field') {
//       this.getType(this.searchData['field']);
//     }
//   }

//   /**
//    * Get type of value
//    * @param value
//    */
//   getType(value: any) {
//     let _self = this;
//     _self.filterAttributes.forEach((e: any) => {
//       if (e.code === value) {
//         this.searchData['value'] = '';
//         _self.selectedSearchAtt = e?.type;
//       }
//     });
//   }

//   /**
//    * Filter type operators
//    */
//   operators = [
//     { label: '=', value: 'EQ' },
//     { label: '!=', value: 'NEQ' },
//     { label: '>', value: 'GT' },
//     { label: '<', value: 'LT' },
//     { label: '>=', value: 'GTE' },
//     { label: '<=', value: 'LTE' },
//     { label: 'like', value: 'LIKE' },
//     { label: 'between', value: 'BETWEEN' },
//     { label: 'Not Null', value: 'NOT NULL' },
//     { label: 'Null', value: 'NULL' },
//     { label: 'Empty', value: 'EMPTY' },
//     { label: 'Day', value: 'DAY' },
//     { label: 'Month', value: 'MONTH' },
//     { label: 'Day & Month', value: 'DAY_AND_MONTH' },
//   ];

//   // Component mein
//   selectedDay: string = 'Today';
//   selectedMonth: string = 'CURRENT';

//   days = [
//     'Today',
//     '01',
//     '02',
//     '03',
//     '04',
//     '05',
//     '06',
//     '07',
//     '08',
//     '09',
//     '10',
//     '11',
//     '12',
//     '13',
//     '14',
//     '15',
//     '16',
//     '17',
//     '18',
//     '19',
//     '20',
//     '21',
//     '22',
//     '23',
//     '24',
//     '25',
//     '26',
//     '27',
//     '28',
//     '29',
//     '30',
//     '31',
//   ];

//   months = [
//     { value: 'CURRENT', name: 'Current Month' },
//     { value: '01', name: 'January' },
//     { value: '02', name: 'February' },
//     { value: '03', name: 'March' },
//     { value: '04', name: 'April' },
//     { value: '05', name: 'May' },
//     { value: '06', name: 'June' },
//     { value: '07', name: 'July' },
//     { value: '08', name: 'August' },
//     { value: '09', name: 'September' },
//     { value: '10', name: 'October' },
//     { value: '11', name: 'November' },
//     { value: '12', name: 'December' },
//   ];

//   dayDropdownOpen = false;

//   toggleDayDropdown() {
//     this.dayDropdownOpen = !this.dayDropdownOpen;
//   }

//   selectDay(day: string) {
//     this.selectedDay = day;
//     this.dayDropdownOpen = false;
//     this.onDayChange();
//   }
//   monthDropdownOpen = false;

//   toggleMonthDropdown() {
//     this.monthDropdownOpen = !this.monthDropdownOpen;
//   }

//   selectMonth(month: any) {
//     this.selectedMonth = month.value;
//     this.monthDropdownOpen = false;
//     this.onMonthChange();
//   }
//   selectDayForDayMonth(day: string) {
//     this.selectedDay = day;
//     this.dayDropdownOpen = false;
//     this.onDayMonthChange();
//   }

//   selectMonthForDayMonth(month: any) {
//     this.selectedMonth = month.value;
//     this.monthDropdownOpen = false;
//     this.onDayMonthChange();
//   }
//   getMonthName(value: string) {
//     return this.months.find((m) => m.value === value)?.name;
//   }

//   onDayChange() {
//     if (this.selectedDay) {
//       const date = new Date();
//       const currentYear = date.getFullYear();
//       const currentMonth = String(date.getMonth() + 1).padStart(2, '0');

//       let day = this.selectedDay;

//       // FIX ONLY FOR "today"
//       if (this.selectedDay === 'Today') {
//         day = String(date.getDate()).padStart(2, '0');
//       }

//       // this.searchData[
//       //   'value'
//       // ] = `${currentYear}-${currentMonth}-${this.selectedDay}`;

//       this.searchData['value'] = `${currentYear}-${currentMonth}-${day}`;
//     }
//   }

//   onMonthChange() {
//     if (this.selectedMonth) {
//       const date = new Date();
//       const currentYear = date.getFullYear();
//       const currentDay = String(date.getDate()).padStart(2, '0');
//       // const month = String(this.selectedMonth).padStart(2, '0');

//       let month = this.selectedMonth;

//       //  FIX ONLY FOR "THIS MONTH"
//       if (this.selectedMonth === 'CURRENT') {
//         month = String(date.getMonth() + 1).padStart(2, '0');
//         console.log(month);
//       }

//       // this.searchData[
//       //   'value'
//       // ] = `${currentYear}-${this.selectedMonth}-${currentDay}`;

//       this.searchData['value'] = `${currentYear}-${month}-${currentDay}`;
//     }
//   }

//   onDayMonthChange() {
//     if (this.selectedDay && this.selectedMonth) {
//       const date = new Date();
//       const currentYear = new Date().getFullYear();

//       let month = this.selectedMonth;
//       let day = this.selectedDay;

//       // FIX ONLY FOR "THIS MONTH"
//       if (this.selectedMonth === 'CURRENT') {
//         month = String(date.getMonth() + 1).padStart(2, '0');
//         console.log(month);
//       }

//       //  FIX ONLY FOR "today"
//       if (this.selectedDay === 'Today') {
//         day = String(date.getDate()).padStart(2, '0');
//       }

//       // this.searchData[
//       //   'value'
//       // ] = `${currentYear}-${this.selectedMonth}-${this.selectedDay}`;

//       this.searchData['value'] = `${currentYear}-${month}-${day}`;
//     }
//   }

//   ranges: any = {
//     Today: [new Date(), new Date()],
//     Yesterday: [
//       new Date(new Date().setDate(new Date().getDate() - 1)),
//       new Date(new Date().setDate(new Date().getDate() - 1)),
//     ],
//     'This Week': [
//       new Date(new Date().setDate(new Date().getDate() - new Date().getDay())),
//       new Date(
//         new Date().setDate(new Date().getDate() + (6 - new Date().getDay())),
//       ),
//     ],
//     'Last Week': [
//       new Date(
//         new Date().setDate(new Date().getDate() - new Date().getDay() - 7),
//       ),
//       new Date(
//         new Date().setDate(new Date().getDate() - new Date().getDay() - 1),
//       ),
//     ],
//     'This Month': [
//       new Date(new Date().getFullYear(), new Date().getMonth(), 1),
//       new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0),
//     ],
//     'Last Month': [
//       new Date(new Date().getFullYear(), new Date().getMonth() - 1, 1),
//       new Date(new Date().getFullYear(), new Date().getMonth(), 0),
//     ],
//   };
// }



import { Component, ElementRef, inject, Input, ViewChild } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { UiformBaseComponent } from '../components/uiform/uiform-base/uiform-base.component';
import { ServiceLocatorService } from '@ncs/ncs-lib';
import { ActivatedRoute } from '@angular/router';
import { ChangeDetectorRef } from '@angular/core';
import { SharedataService } from '../common/service/sharedata.service';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-reports-list',
  templateUrl: './reports-list.component.html',
  styleUrls: ['./reports-list.component.css'],
})
export class ReportsListComponent extends UiformBaseComponent {
  @ViewChild('content')
  content!: ElementRef;
  public reportData: any = {};
  public show: boolean = false;
  public loading: boolean = false;
  dropdownOpen: boolean = false;
  public searchReport: any;
  public selectedSearchAtt: any;
  @Input() searchList: any[] = [];

  public reqform: any = {
    chart_type: 'html',
    margins: false,
  };
  public pivotform: any = {
    chart_type: 'html',
  };
  public sanitizedData: any = [];
  private sanitizer = inject(DomSanitizer);
  pivotUrl: SafeResourceUrl | null = null;
  pivottable: any = '<div><div>';
  public reportTitle: any = '';
  public reportId: number | null = 0;
  public override appId: any = null;
  public appName: any;
  public orgName: any;
  public appLogoId: any;
  public orgLogoId: any;
  searchData: any = {};
  searchView: any = {};
  chartUrl: string | null = null;

  constructor(
    public override locator: ServiceLocatorService,
    public override route: ActivatedRoute,
    private cdRef: ChangeDetectorRef,
    private sharedata: SharedataService,
  ) {
    super(locator, route);
    let _self = this;

    const reportIdParam = route.snapshot.paramMap.get('reportId');
    const appIdParam =
      route.snapshot.paramMap.get('appId') || route.snapshot.paramMap.get('id');

    if (reportIdParam) {
      _self.reportId = Number(reportIdParam);
    }

    if (appIdParam) {
      _self.appId = Number(appIdParam);
    }

    // Also check path variables dynamically
    _self.locator.getPathVariable(route, function (params: any) {
      if (params['reportId']) {
        _self.reportId = locator.dataValidator.toInt(params['reportId']);
      }
      if (params['appId'] || params['id']) {
        _self.appId = locator.dataValidator.toInt(
          params['appId'] || params['id'],
        );
      }
      _self.ngOnInit();
    });
  }

  override ngOnInit() {
    let _self = this;
    let keySuffix = _self.locator.config.get('CONTEXT_PATH') + '-';
    _self.appName = localStorage.getItem(keySuffix + 'appName');
    _self.orgName = localStorage.getItem(keySuffix + 'orgName');
    _self.orgLogoId = localStorage.getItem(keySuffix + 'orgLogo');
    _self.appLogoId = localStorage.getItem(keySuffix + 'appLogoId');

    // Initialize searchList if not provided
    if (!_self.searchList || !Array.isArray(_self.searchList)) {
      _self.searchList = [];
    }

    if (_self.reportId && _self.reportId > 0) {
      _self.getReportData(_self.reportId);
    }
  }

  /**
   * Get Report Data
   * @param id
   * @returns
   */
  public getReportData(id: number | null) {
    let _self = this;
    if (!id || !(id > 0)) {
      return;
    }
    _self.locator.config
      .getProperty('endpoint.reports')
      .then((property: string) => {
        let url = property + '/get/' + id;
        _self.locator.http.get(url, function (res: any, error: boolean) {
          if (error) {
            alert('Server Error:' + error);
            return;
          }
          _self.form['data'] = res.result['data'];

          _self.searchList = res.result['data']?.searchList || [];
          _self.getDetails(
            true,
            res.result['data']['dataJson'],
            res.result['data']['title'],
            res.result['data']['uiFormId']
          );
          _self.preload();
        });
      });
  }

  getReports(callback?: any) {
    var _self = this;
    _self.form.searchError = false;
    _self.form.searchMessage = '';

    _self.locator.config
      .getProperty('endpoint.reports')
      .then((property: string) => {
        let url = property + '/search/' + _self.form.pageNo;

        _self.locator.http.post(
          url,
          _self.form.searchParams,
          function (res: any, error: any) {
            if (error) {
              if (callback) {
                callback(error);
              }
              return;
            }

            _self.form.searchError = !res.success;
            _self.form.searchMessage = res.result['message'];

            if (res.success) {
              _self.form.list = res.result.data;
              //Check empty list
              if (_self.form.list.length == 0) {
                _self.form.message = 'No record found';
                _self.form.error = true;
              }
              if (callback) {
                callback();
              }
            }

            if (callback) {
              callback();
            }
          },
        );
      });
  }

  /**
   * Toggle the value of Search button
   */
  showSearch() {
    let _self = this;
    _self.show = !_self.show;
  }

  //-------------------------------------------------------------------------------------------------------

  /**
   * Reset search from
   */
  override resetSearchForm() {
    this.form.searchError = false;
    this.form.searchMessage = '';
    this.form.searchParams = {};
  }

  override preload() {
    var _self = this;
    _self.form.error = false;
    _self.form.message = '';
    this.locator.config
      .getProperty('endpoint.reports')
      .then((property: any) => {
        this.locator.http.get(_self.api.preload, (res: any, error: any) => {
          if (error) {
            return;
          }
          _self.form.error = !res.success;
          _self.form.message = res.result.message;
          if (res.success) {
            _self.form.preload = res.result;
            // Set a 2-second delay to call clearMessage
            setTimeout(() => {
              this.clearMessage(_self.form);
            }, 2000);
          }
        });
      });
  }

  /**
   * Main function to get Pivot GUI
   * @param flag
   */
  async searchAndDraw(flag: boolean, searchdata: any, title: any) {
    let _self = this;
    _self.reportTitle = title;
    _self.reqform = searchdata;
    if (flag) {
      this.searchCriteria(() => {
        _self.cleanData();
        _self.findNumericFields();
        _self.getPivotGui();
      });
    } else {
      _self.getPivotGui();
    }
  }

  /**
   * Remove common attributes from searched result data
   */
  public cleanData(): any {
    let _self = this;

    if (!_self.usecaseData || !_self.usecaseData.length) {
      console.warn('cleanData skipped: empty usecaseData');
      _self.sanitizedData = [];
      return;
    }

    const allowedKeysMap = _self.filterAttributes.reduce(
      (map: any, attr: any) => {
        if (attr['code'] && attr['label']) {
          map[attr['code']] = attr['label'];
        }
        return map;
      },
      {},
    );

    _self.sanitizedData = _self.usecaseData.map((item: any) => {
      const sanitizedItem: any = {};
      Object.keys(allowedKeysMap).forEach((key: string) => {
        if (key in item) {
          sanitizedItem[allowedKeysMap[key]] = item[key];
        }
      });
      return sanitizedItem;
    });
  }

  /**
   * Create Pivot GUI from server side
   */
  getPivotGui() {
    let _self = this;
    _self.loading = true;
    _self.reportData = {};
    _self.form['error'] = false;
    _self.form['message'] = '';
    _self.pivottable = '';
    _self.pivotUrl = null;
    _self.reqform['title'] = _self.usecase['name'];
    _self.reqform['values'] = this.reqform['aggfunc']
      ? Object.keys(this.reqform['aggfunc'])
      : [];
    _self.reqform['numericfields'] = _self.findNumericFields();
    _self.reportData = _self.reqform;

    if (!_self.sanitizedData || !_self.sanitizedData.length) {
      console.warn('No sanitized data for pivot');
      _self.pivottable = '';
      _self.pivotUrl = null;
      _self.form.error = true;
      _self.form.message = 'No data found';
      _self.loading = false;
      return;
    }

    if (_self.reqform['chart_type'] === 'html') {
      _self.locator.config
        .getProperty('endpoint.pivot')
        .then((property: string) => {
          let url = _self.urlRewrite(property);

          _self.reqform['data'] = _self.sanitizedData;

          let client = _self.locator.http.getClient();

          client.post(url, _self.reqform, { responseType: 'text' }).subscribe(
            (data: any) => {
              try {
                const jsonResponse = JSON.parse(data);
                if (!jsonResponse['success']) {
                  _self.form['error'] = true;
                  _self.form['message'] = jsonResponse['message'];
                  _self.loading = false;
                  return;
                }
              } catch (error) {
                console.error('Error parsing JSON from Blob:', error);
              }
              _self.pivottable = data;
              _self.loading = false;
            },
            (data: any) => {
              console.error(data);
              _self.loading = false;
            }
          );
        });
    } else {
      _self.locator.config
        .getProperty('endpoint.pivot')
        .then((property: string) => {
          let url = _self.urlRewrite(property);
          _self.reqform['data'] = _self.sanitizedData;
          let client = _self.locator.http.getClient();
          client.post(url, _self.reqform, { responseType: 'blob' }).subscribe(
            (data: any) => {
              const contentType = data.type;
              if (contentType.includes('application/json')) {
                const reader = new FileReader();
                reader.onload = () => {
                  const text = reader.result as string;
                  try {
                    const jsonResponse = JSON.parse(text);
                    if (!jsonResponse['success']) {
                      _self.form['error'] = true;
                      _self.form['message'] = jsonResponse['message'];
                    }
                  } catch (error) {
                    console.error('Error parsing JSON from Blob:', error);
                  }
                };
                reader.readAsText(data);
              } else {
                const objectUrl = URL.createObjectURL(data);
                _self.pivotUrl =
                  this.sanitizer.bypassSecurityTrustResourceUrl(objectUrl);
              }
              _self.loading = false;
            },
            (data: any) => {
              _self.loading = false;
            }
          );
        });
    }
  }

  /**
   * Function to find all numeric fields
   * @returns
   */
  findNumericFields = () => {
    const numericFields = new Set();
    this.sanitizedData.forEach((item: any) => {
      Object.keys(item).forEach((key) => {
        if (typeof item[key] === 'number') {
          numericFields.add(key);
        }
      });
    });
    return Array.from(numericFields);
  };

  /**
   * Reset search values
   */
  resetSearchValues() {
    this.searchValues = {};
    this.searchAndDrawnew(true);
  }

  /**
   * Update form field
   * @param field
   * @param value
   * @param aggValue
   * @param isKey
   */
  updateFormField(
    field: string,
    value: any,
    aggValue?: any,
    isKey: boolean = false
  ) {
    this.reqform[field] = this.reqform[field] || (isKey ? {} : []);
    if (isKey) {
      aggValue = aggValue?.trim() || 'sum';
      this.reqform[field][value] = aggValue;
    } else {
      this.reqform[field].push(value);
    }
  }

  /**
   * Remove form field
   * @param field
   * @param value
   * @param isKey
   */
  removeFormField(field: string, value: any, isKey: boolean = false) {
    if (isKey) {
      delete this.reqform[field]?.[value];
    } else if (Array.isArray(this.reqform[field])) {
      const index = this.reqform[field].indexOf(value);
      if (index > -1) this.reqform[field].splice(index, 1);
    }
  }

  /**
   * Search and draw pivot data
   * ✅ FIX: Reset all stale state FIRST before any async work begins
   * @param flag
   * @param searchdata
   * @param title
   * @param uiformId
   */
  async getDetails(flag: boolean, searchdata: any, title: any, uiformId: any) {
    let _self = this;
    _self.is_paging = false;

    // ✅ FIX 1: Clear all stale data immediately so old Table A data never shows for Table B
    _self.sanitizedData = [];
    _self.usecaseData = [];
    _self.pivottable = '';
    _self.pivotUrl = null;
    _self.loading = true;
    _self.form.error = false;
    _self.form.message = '';

    if (uiformId) {
      try {
        const endpoint = await _self.locator.config.getProperty(
          'endpoint.ui.forms'
        );

        await new Promise<void>((resolve) => {
          _self.get(uiformId, async function () {
            _self.usecaseId = _self.form.data.userstoryId;

            await _self.getUsecaseSchema(false, async () => {
              _self.filterAttributes = await _self.getFilterAttributes(
                _self.usecaseAttributes,
                _self.form.data['fields']
              );
              resolve();
            });
          });
        });

        // Call searchAndDraw only after all operations are complete
        _self.searchAndDraw(flag, searchdata, title);
      } catch (error) {
        console.error('Error in getDetails:', error);
        _self.loading = false;
      }
    } else {
      // uiformId nahi hai
      _self.loading = false;
    }
  }

  /**
   * Draw pivot data
   * @param flag
   */
  searchAndDrawnew(flag: boolean) {
    let _self = this;

    if (flag) {
      this.searchCriteria(() => {
        _self.cleanData();
        _self.findNumericFields();
        _self.getPivotGui();
      });
    } else {
      _self.getPivotGui();
    }
  }

  /**
   * search for parent usecase dependency
   * @param e
   * @param value
   */
  override onSearchReferenceValueChange(e: any, value: any) {
    this.searchValues[e.code] =
      e.type === 'number' ? parseFloat(value.target.value) : value.target.value;
    let _self = this;
    if (
      _self.usecase !== undefined &&
      _self.usecase['parentUsecaseDependency'] !== undefined &&
      _self.usecase['parentUsecaseDependency'][e['primaryUsecase']] !==
      undefined
    ) {
      _self.primaryUsecaseDependencyFilter(
        _self.usecase['parentUsecaseDependency'][e['primaryUsecase']],
        value
      );
    }
  }

  /***
   * primaryUsecaseDependencyFilter
   */
  primaryUsecaseDependencyFilter(data: any, val: any) {
    let _self = this;
    let key = val['target']['id'];
    let [appCode, codes] = (data['code'] ?? '').toString().split('.');
    let url =
      _self.locator.config.get('endpoint.api.v1') +
      '/' +
      appCode +
      '/' +
      codes +
      '/preloadData';
    let searchParams = {
      [key]: parseFloat(val['target']['value']),
    };
    _self.locator.http.post(
      url,
      searchParams,
      function (res: any, error: boolean) {
        if (error) {
          return;
        }
        _self.form.preload[data['code']] = res.result[data['code']];
      }
    );
  }

  addSearchData() {
    let _self = this;

    // Date validation and today/yesterday detection
    if (
      _self.selectedSearchAtt === 'date' &&
      _self.searchData['condition'] !== 'BETWEEN'
    ) {
      if (
        _self.searchData['condition'] !== 'DAY' &&
        _self.searchData['condition'] !== 'MONTH' &&
        _self.searchData['condition'] !== 'DAY_AND_MONTH' &&
        ['NULL', 'NOT NULL', 'EMPTY'].indexOf(_self.searchData['condition']) ===
        -1
      ) {
        if (!_self.searchData['value']) {
          alert('Date is empty');
          return;
        } else {
          const searchDate = new Date(_self.searchData['value']);
          const currentDate = new Date();
          const yesterDate = new Date();

          searchDate.setHours(0, 0, 0, 0);
          currentDate.setHours(0, 0, 0, 0);
          yesterDate.setDate(currentDate.getDate() - 1);
          yesterDate.setHours(0, 0, 0, 0);

          if (searchDate.getTime() === currentDate.getTime()) {
            _self.searchData['date'] = 'today';
          } else if (searchDate.getTime() === yesterDate.getTime()) {
            _self.searchData['date'] = 'yesterday';
          } else {
            console.log('The date is neither today nor yesterday.');
          }
        }
      }
    }

    // Parse rangeDate from ngxDaterangepickerMd
    if (_self.searchData['rangeDate']) {
      _self.searchData['rangeFrom'] =
        _self.searchData.rangeDate.startDate.format('YYYY-MM-DD');
      _self.searchData['rangeTo'] =
        _self.searchData.rangeDate.endDate.format('YYYY-MM-DD');
    }

    // Field validation
    if (!_self.searchData['field']) {
      alert('Field is empty');
      return;

      // Condition validation
    } else if (!_self.searchData['condition']) {
      alert('Condition is empty');
      return;

      // BETWEEN handling
    } else if (_self.searchData['condition'] === 'BETWEEN') {
      if (!_self.searchData['rangeFrom']) {
        alert('From value is empty');
        return;
      }

      if (!_self.searchData['rangeTo']) {
        alert('To value is empty');
        return;
      }

      let payload = {
        ..._self.searchData,
        value: undefined,
      };

      _self.searchList.push(payload);

      _self.operators.forEach((e: any) => {
        if (_self.searchData['condition'] === e.value) {
          payload['label'] = _self.searchData['field'];
          payload['conditionLabel'] = e.label;
        }
      });

      // Reset
      _self.searchData = {};
      _self.searchView['field'] = '';
      _self.selectedSearchAtt = undefined;
    } else {
      // Skip value check for NULL / NOT NULL / EMPTY
      if (
        ['NULL', 'NOT NULL', 'EMPTY'].indexOf(_self.searchData['condition']) ===
        -1 &&
        !_self.searchData['value']
      ) {
        alert('Value is empty');
        return;
      }

      // EMPTY condition for number field → set value to 0
      if (
        _self.searchData['condition'] === 'EMPTY' &&
        _self.selectedSearchAtt === 'number'
      ) {
        _self.searchData['value'] = 0;
      }

      // Numeric field type coercion
      const normalizedNumericFields = _self
        .findNumericFields()
        .map((label: any) => label.toLowerCase().replace(/\s+/g, ''));
      const normalizedField = _self.searchData.field
        .toLowerCase()
        .replace(/\s+/g, '');

      if (normalizedNumericFields.includes(normalizedField)) {
        const numValue = Number(_self.searchData.value);
        if (!isNaN(numValue)) {
          _self.searchData.value = numValue;
        }
      }

      // Push to searchList
      _self.searchList.push(_self.searchData);

      // Reset
      _self.searchData = {};
      _self.searchView['field'] = '';
      _self.selectedSearchAtt = undefined;
    }
  }

  /**
   * Reset search data
   * @param index
   */
  removeSearchData(index: any) {
    if (index > -1) this.searchList.splice(index, 1);
  }

  /**
   * Reset search criteria
   */
  resetSearchCriteria() {
    this.searchList = [];
    this.searchData = {};
    this.searchView = {};
  }

  /**
   * Search criteria
   * @param callback
   */
  searchCriteria(callback?: any) {
    let _self = this;

    const datePipe = new DatePipe('en-US');
    _self.searchList.forEach((e: any) => {
      const currentDate = new Date();
      if (e?.date === 'today') {
        console.log('today');
        e['value'] = datePipe.transform(currentDate, 'yyyy-MM-dd');
      } else if (e?.date === 'yesterday') {
        console.log('yesterday');
        // ✅ FIX 2: Subtract 1 full day, not 1 millisecond
        const yesterday = new Date(currentDate);
        yesterday.setDate(yesterday.getDate() - 1);
        e['value'] = datePipe.transform(yesterday, 'yyyy-MM-dd');
      }
    });

    let searchCriteria = {
      searchList: _self.searchList,
    };

    let url = _self.apiurl + '/searchCriteria';

    this.locator.http.post(
      url,
      searchCriteria,
      function (res: any, error: any) {
        console.log('API Response =>', res);
        console.log('API Success =>', res?.success);
        console.log('API Data =>', res?.result?.data);

        if (error) {
          if (callback) {
            callback(error);
          }
          return;
        }

        if (res.success) {
          _self.usecaseData = res.result['data'] || [];

          console.log('Search Result =>', _self.usecaseData);
          console.log('Search Result =>', res.result['data']);

          // No data found
          if (!_self.usecaseData.length) {
            _self.sanitizedData = [];
            _self.pivottable = '';
            _self.pivotUrl = null;
            _self.form.error = true;
            _self.form.message = 'No data found';
            _self.loading = false;  // ✅ loading band karo
            return;                 // ✅ yahan return, callback mat chalao
          }

          if (callback) {
            callback();
          }
        } else {
          // API call failed / success false
          _self.loading = false;   // ✅ error case mein bhi loading band karo
        }

        _self.processData();
      },
    );
  }

  /**
   * Button labels for pivot table
   * @param type
   * @returns
   */
  getButtonLabels(type: string): string {
    const typeMap: { [key: string]: string } = {
      text: 'T',
      number: 'N',
      long: 'L',
      date: 'D',
      decimal: 'Dc',
      doc: 'Doc',
      email: 'E',
      expression: 'Exp',
      file: 'F',
      list: 'L',
      map: 'C',
      object: 'O',
      password: 'Pwd',
      phone: 'Phn',
      textarea: 'TA',
      url: 'Url',
      time: 'T',
    };
    return typeMap[type] || '?';
  }

  /**
   * Button class for pivot table
   * @param type
   * @returns
   */
  getButtonClass(type: string): string {
    const typeClassMap: { [key: string]: string } = {
      text: 'text-bg-success',
      number: 'text-bg-primary',
      date: 'text-bg-warning',
      long: 'text-bg-primary',
      decimal: 'text-bg-primary',
      doc: 'text-bg-info',
      email: 'text-bg-success',
      expression: 'text-bg-info',
      file: 'text-bg-secondary',
      list: 'text-bg-danger',
      map: 'text-bg-dark',
      object: 'text-bg-secondary',
      password: 'text-bg-warning',
      phone: 'text-bg-success',
      textarea: 'text-bg-success',
      url: 'text-bg-info',
      keyvalue: 'text-bg-info',
      image: 'text-bg-info',
    };
    return typeClassMap[type] || 'text-bg-success';
  }

  /**
   * Toggle dropdown
   */
  toggleDropdown() {
    this.dropdownOpen = !this.dropdownOpen;
  }

  /**
   * Select column value set
   * @param value
   * @param key
   */
  selectColumn(value: string, key: string) {
    this.pivotform[key] = value;
  }

  /**
   * Select search value set
   * @param value
   * @param key
   */
  selectSearch(value: any, key: string) {
    this.searchData[key] = value['code'];
    this.searchData['label'] = value['label'];
    this.searchView[key] = value['label'];
    if (key === 'field') {
      this.getType(this.searchData['field']);
    }
  }

  /**
   * Get type of value
   * @param value
   */
  getType(value: any) {
    let _self = this;
    _self.filterAttributes.forEach((e: any) => {
      if (e.code === value) {
        this.searchData['value'] = '';
        _self.selectedSearchAtt = e?.type;
      }
    });
  }

  /**
   * Filter type operators
   */
  operators = [
    { label: '=', value: 'EQ' },
    { label: '!=', value: 'NEQ' },
    { label: '>', value: 'GT' },
    { label: '<', value: 'LT' },
    { label: '>=', value: 'GTE' },
    { label: '<=', value: 'LTE' },
    { label: 'like', value: 'LIKE' },
    { label: 'between', value: 'BETWEEN' },
    { label: 'Not Null', value: 'NOT NULL' },
    { label: 'Null', value: 'NULL' },
    { label: 'Empty', value: 'EMPTY' },
    { label: 'Day', value: 'DAY' },
    { label: 'Month', value: 'MONTH' },
    { label: 'Day & Month', value: 'DAY_AND_MONTH' },
  ];

  selectedDay: string = 'Today';
  selectedMonth: string = 'CURRENT';

  days = [
    'Today',
    '01', '02', '03', '04', '05', '06', '07', '08', '09', '10',
    '11', '12', '13', '14', '15', '16', '17', '18', '19', '20',
    '21', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31',
  ];

  months = [
    { value: 'CURRENT', name: 'Current Month' },
    { value: '01', name: 'January' },
    { value: '02', name: 'February' },
    { value: '03', name: 'March' },
    { value: '04', name: 'April' },
    { value: '05', name: 'May' },
    { value: '06', name: 'June' },
    { value: '07', name: 'July' },
    { value: '08', name: 'August' },
    { value: '09', name: 'September' },
    { value: '10', name: 'October' },
    { value: '11', name: 'November' },
    { value: '12', name: 'December' },
  ];

  dayDropdownOpen = false;

  toggleDayDropdown() {
    this.dayDropdownOpen = !this.dayDropdownOpen;
  }

  selectDay(day: string) {
    this.selectedDay = day;
    this.dayDropdownOpen = false;
    this.onDayChange();
  }

  monthDropdownOpen = false;

  toggleMonthDropdown() {
    this.monthDropdownOpen = !this.monthDropdownOpen;
  }

  selectMonth(month: any) {
    this.selectedMonth = month.value;
    this.monthDropdownOpen = false;
    this.onMonthChange();
  }

  selectDayForDayMonth(day: string) {
    this.selectedDay = day;
    this.dayDropdownOpen = false;
    this.onDayMonthChange();
  }

  selectMonthForDayMonth(month: any) {
    this.selectedMonth = month.value;
    this.monthDropdownOpen = false;
    this.onDayMonthChange();
  }

  getMonthName(value: string) {
    return this.months.find((m) => m.value === value)?.name;
  }

  onDayChange() {
    if (this.selectedDay) {
      const date = new Date();
      const currentYear = date.getFullYear();
      const currentMonth = String(date.getMonth() + 1).padStart(2, '0');

      let day = this.selectedDay;

      if (this.selectedDay === 'Today') {
        day = String(date.getDate()).padStart(2, '0');
      }

      this.searchData['value'] = `${currentYear}-${currentMonth}-${day}`;
    }
  }

  onMonthChange() {
    if (this.selectedMonth) {
      const date = new Date();
      const currentYear = date.getFullYear();
      const currentDay = String(date.getDate()).padStart(2, '0');

      let month = this.selectedMonth;

      if (this.selectedMonth === 'CURRENT') {
        month = String(date.getMonth() + 1).padStart(2, '0');
        console.log(month);
      }

      this.searchData['value'] = `${currentYear}-${month}-${currentDay}`;
    }
  }

  onDayMonthChange() {
    if (this.selectedDay && this.selectedMonth) {
      const date = new Date();
      const currentYear = new Date().getFullYear();

      let month = this.selectedMonth;
      let day = this.selectedDay;

      if (this.selectedMonth === 'CURRENT') {
        month = String(date.getMonth() + 1).padStart(2, '0');
        console.log(month);
      }

      if (this.selectedDay === 'Today') {
        day = String(date.getDate()).padStart(2, '0');
      }

      this.searchData['value'] = `${currentYear}-${month}-${day}`;
    }
  }

  ranges: any = {
    Today: [new Date(), new Date()],
    Yesterday: [
      new Date(new Date().setDate(new Date().getDate() - 1)),
      new Date(new Date().setDate(new Date().getDate() - 1)),
    ],
    'This Week': [
      new Date(new Date().setDate(new Date().getDate() - new Date().getDay())),
      new Date(
        new Date().setDate(new Date().getDate() + (6 - new Date().getDay())),
      ),
    ],
    'Last Week': [
      new Date(
        new Date().setDate(new Date().getDate() - new Date().getDay() - 7),
      ),
      new Date(
        new Date().setDate(new Date().getDate() - new Date().getDay() - 1),
      ),
    ],
    'This Month': [
      new Date(new Date().getFullYear(), new Date().getMonth(), 1),
      new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0),
    ],
    'Last Month': [
      new Date(new Date().getFullYear(), new Date().getMonth() - 1, 1),
      new Date(new Date().getFullYear(), new Date().getMonth(), 0),
    ],
  };
}
